<ng-container *transloco="let t">
  @if (isAdmin) {
    <div class="d-flex justify-content-between admin-template">
      @if (filteringEnabled) {
        <div class="d-flex flex-column flex-xxl-row">
          <div class="pe-2">
            <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
          </div>
          <div class="w-180 d-flex ">
            <app-select [hasDefault]="true" [items]="genders" [ngModel]="gender"
                        [defaultValue]="undefined" [defaultLabel]="t('app.common.all')"
                        labelKey="id" valueKey="id"
                        labelKeyPrefix="app.common.gender." (ngModelChange)="handleGenderSelection($event)"
                        [fullWidthDropdown]="true"/>
          </div>
          @if ((categories?.length ?? 0) > 0) {
            <div class="ps-2">
              <app-select [hasDefault]="true" [items]="categories"
                          [ngModel]="category"
                          [defaultValue]="undefined" [defaultLabel]="t('app.common.all')"
                          [valueKey]="'id'" [labelKey]="'name'"
                          (ngModelChange)="handleCategorySelection($event)"
                          [fullWidthDropdown]="true"/>
            </div>
          }
        </div>
      }
      <ng-content select="[slot='resultsTableAdminTrailingWidgets']"></ng-content>
    </div>
  }
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="table-responsive results-table">
    @if (filteringEnabled && !isAdmin) {
      <div class="contestants-filter py-3 mb-3">
        <div class="d-flex flex-column flex-md-row">
          <div class="px-0 px-lg-4 px-md-0 me-md-3 pb-3 pb-md-0">
            <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                        (searchQuery)="handleSearchInput($event)" [inputValue]="name"/>
          </div>
          <form #f>
            <div class="contestants-filter__grid">
              <div class="contestants-filter__grid-inner">
                <div ngbDropdown class="dropdown-small" container="body">
                  <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                    {{
                      gender
                        ? t("app.common.gender." + gender) : t("competitor.table.gender")
                    }}
                  </div>
                  @if (genders?.length ?? 0 > 0) {
                    <div ngbDropdownMenu aria-labelledby="genderDropdown">
                      <button ngbDropdownItem (click)="handleGenderSelection()">
                        {{ t("app.common.all") }}
                        @if ((gender === undefined)) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      @for (item of genders;track item) {
                        <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                          {{ t("app.common.gender." + item.id) }}
                          @if (item.id === gender) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                      }
                    </div>
                  }
                </div>
                <div>
                  @if (categories?.length ?? 0 > 0) {
                    <div ngbDropdown class="dropdown-small" container="body">
                      <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                        {{ category ? category : t("competitor.table.category") }}
                      </div>
                      <div ngbDropdownMenu aria-labelledby="categoryDropdown">
                        <button ngbDropdownItem (click)="handleCategorySelection()">
                          {{ t("app.common.all") }}
                          @if ((category === undefined)) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                        @for (item of categories;track item) {
                          <button ngbDropdownItem (click)="handleCategorySelection(item.id)">
                            {{ item.name }}
                            @if (item.id == category) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
    <ng-content/>
    @if (results?.length ?? 0 > 0) {
      <div>
        @for (competitor of results;track competitor) {
          <ng-container>
            <div class="align-items-center d-flex d-lg-none">
              <div class="pe-4 fw-bolder fs-5">
                {{ (competitor.absoluteRank !== 0) ? competitor.absoluteRank : "-" }}
              </div>
              <div class="d-flex flex-column py-3 item-border-bottom flex-grow-1">
                <div class="d-flex align-items-end">
            <span class="fw-bold line-height-12">
              {{
                ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                  ?? "") | titlecase)
              }}
            </span>
                  <div [ngClass]="{'fs-13-px fw-semibold': !isAdmin}">
                    <div>{{ ', ' }}{{ t("app.common.gender." + competitor.sex) }}</div>
                  </div>
                </div>
                <div [ngClass]="{'fs-13-px fw-semibold': !isAdmin}">
                  <div class="d-inline-flex">
                    {{ t('competitor.table.start.number') }} {{ ': ' }} {{ competitor.startNumber }}
                  </div>
                </div>
                <div class="d-flex mt-1">
            <span class="badge rounded-pill">
              {{ t("competitor.table.status." + competitor.status) }}
            </span>
                </div>
              </div>
            </div>
          </ng-container>
        }
        <div class="d-none d-lg-flex">
          <table [ngClass]="['table', 'align-middle', 'header', 'dark-header', !isAdmin ? 'table-striped' : '']">
            <thead class="sticky-table-header">
            <tr>
              <th scope="col" class="rank-column-width">{{ t("competitor.table.absolute.rank") }}</th>
              <th scope="col" class="start-number-column-width">{{ t('competitor.table.start.number') }}</th>
              <th scope="col" class="name-column-width">{{ t('competitor.table.first.and.last.name') }}</th>
              <th scope="col" class="gender-column-width">{{ t('competitor.table.gender') }}</th>
              <th scope="col" class="status-column-width">{{ t('competitor.table.status') }}</th>
              @if (showRaceNameInTable) {
                <th scope="col">{{ t('competitor.table.race.name') }}</th>
              }
              @if (showDateOfBirthInTable) {
                <th scope="col" class="date-of-birth-column-width">{{ t('app.common.birthDay') }}</th>
              }
            </tr>
            </thead>
            <tr app-table-header-separator></tr>
            <tbody #tbody>
              @for (competitor of results;track competitor) {
                <tr [ngClass]="{'fs-13-px fw-semibold': !isAdmin}" [style.height]="isAdmin ? '57px' : 'auto'">
                  <th scope="row">{{ (competitor.absoluteRank !== 0) ? competitor.absoluteRank : "-" }}</th>
                  <td>{{ competitor.startNumber }}</td>
                  <td [class.fw-semibold]="isAdmin"> {{
                      ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName ?? "") | titlecase)
                    }}
                  </td>
                  <td>{{ t("app.common.gender." + competitor.sex) }}</td>
                  <td>{{ competitor.status ? t("competitor.table.status." + competitor.status) : "-" }}</td>
                  @if (showRaceNameInTable) {
                    <td>
                      <app-language-output [hrLabel]="competitor.race?.name" [enLabel]="competitor.race?.nameEng"
                                           [itLabel]="competitor.race?.nameIta" [siLabel]="competitor.race?.nameSlo"
                                           [defaultLanguage]="currentEventItem?.defaultLanguage"
                                           [languages]="languages"/>
                    </td>
                  }
                  @if (showDateOfBirthInTable) {
                    <!--                    TODO-->
                    <td>
                      -
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    } @else {
      <div class="px-3 px-lg-4 pt-2">
        <app-empty-state [isHorizontalMode]="!isAdmin"/>
      </div>
    }
    @if (hasMore) {
      @if (isAdmin) {
        <div class="pt-16">
          <app-admin-load-more (click)="loadMore()"/>
        </div>
      } @else {
        <div class="d-flex justify-content-center load-more-wrapper py-5">
          <app-rounded-button [label]="t('app.common.load.more')" (onClick)="loadMore()"/>
        </div>
      }
    }
    @if (showFabButton && (results?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>
